import React, { useEffect, useState } from 'react';
import PrimaryCta from './PrimaryCta';

const barStyle: React.CSSProperties = {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
    background: 'rgba(20,20,22,0.98)',
    color: '#fff',
    padding: '12px 16px',
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
};

const textStyle: React.CSSProperties = {
    fontSize: 14,
    lineHeight: 1.4,
    maxWidth: 700,
};

const actionsStyle: React.CSSProperties = {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    alignItems: 'center',
};

const btnBase: React.CSSProperties = {
    border: 0,
    minWidth: 112,
    minHeight: 44,
    padding: '10px 16px',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 14,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const denyBtn: React.CSSProperties = {
    ...btnBase,
    background: '#27272a',
    color: '#fff',
};

const KEY = 'cy-consent-v1';

export default function ConsentBanner() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem(KEY);
        setOpen(!saved);
    }, []);

    const updateConsent = (granted: boolean) => {
        // @ts-ignore
        window.gtag?.('consent', 'update', {
            ad_storage: granted ? 'granted' : 'denied',
            analytics_storage: granted ? 'granted' : 'denied',
            ad_user_data: granted ? 'granted' : 'denied',
            ad_personalization: granted ? 'granted' : 'denied',
        });
    };

    const acceptAll = () => {
        updateConsent(true);
        localStorage.setItem(KEY, JSON.stringify({ choice: 'accept', ts: Date.now() }));
        setOpen(false);
    };

    const denyAll = () => {
        updateConsent(false);
        localStorage.setItem(KEY, JSON.stringify({ choice: 'deny', ts: Date.now() }));
        setOpen(false);
    };

    if (!open) return null;

    return (
        <div style={barStyle} role="dialog" aria-live="polite" aria-label="Cookie consent">
            <div style={textStyle}>
                We use cookies to analyze traffic and improve your experience. You can accept or deny, and
                change your choice later in settings.
            </div>
            <div style={actionsStyle}>
                <button style={denyBtn} onClick={denyAll}>Deny</button>
                <PrimaryCta
                    onClick={acceptAll}
                    style={{ width: 112, minWidth: 112, minHeight: 44, padding: '10px 16px' }}
                >
                    Accept
                </PrimaryCta>
            </div>
        </div>
    );
}
